import { jsx as _jsx } from "react/jsx-runtime";
import { Card as MuiCard } from '@mui/material';
import React from 'react';
import styles from './styles';
export const Card = ({ sx = {}, children, className }) => {
    return (_jsx(MuiCard, { sx: Object.assign(styles.card, sx), className: className, children: children }));
};
